import { Link } from "react-router-dom";
import PageBanner from "../PageBanner";
import SocialMediaSidebar from "../SocialMediaSidebar";
import SectionHeader from "../SectionHeader";
import React, { useState, useEffect } from "react";
import axios from "axios";

import Policy from "../../assets/images/blog3.png";
import vishal from "../../assets/images/vishal.png";

import Slider from "react-slick";
import { CMSAPI } from "../../config";
import ScrollToTopButton from "../ScrollToTopButton";
import SectionHeaderNoPDF from "../SectionHeaderNoPDF";

const Podcast = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [allPodcasts, setAllPodcasts] = useState([]); // Store all podcasts
  const [filteredPodcasts, setFilteredPodcasts] = useState([]); // Store filtered podcasts
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([{ name: "All", count: 0 }]);
  const [selectedPodcast, setSelectedPodcast] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const postsPerPage = 6; // Number of posts to show per page

  // Fetch all podcasts on component mount
  useEffect(() => {
    const fetchAllPodcasts = async () => {
      try {
        setLoading(true);
        // Fetch all podcasts with a large page size
        const response = await axios.get(
          `${CMSAPI}/api/Podcasts/get-podcasts?PageNo=1&PageSize=1000&domain=GYANYANTRAM`
        );

        if (response.data && response.data.data) {
          const transformedPodcasts = response.data.data.map((podcast) => ({
            id: podcast.id,
            img: podcast.photo ? `${CMSAPI}${podcast.photo}` : Policy,
            tag: podcast.category || "Sustainability",
            category: podcast.category || "Uncategorized",
            title: podcast.name || "Untitled Podcast",
            desc: podcast.about || "No description available",
            videoId: podcast.detail || "",
            authorImg: vishal,
            author: "Admin",
            date:
              new Date(podcast.regDate).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              }) || "June 9, 2025",
            slug: podcast.slug || `#${podcast.id}`,
          }));

          setAllPodcasts(transformedPodcasts);
          updateCategories(transformedPodcasts);
          filterAndPaginatePodcasts(transformedPodcasts, "All", 1);
        }
      } catch (err) {
        console.error("Error fetching podcasts:", err);
        setError("Failed to load podcasts. Please try again later.");

        const fallbackPodcasts = [
          {
            id: 1,
            img: Policy,
            tag: "Sustainability",
            category: "AI Waste Management",
            title: "Demo Podcast",
            desc: "An example podcast about waste management",
            videoId: "fdOfcUI_sWk",
            authorImg: vishal,
            author: "Admin",
            date: "June 9, 2025",
          },
        ];

        setAllPodcasts(fallbackPodcasts);
        updateCategories(fallbackPodcasts);
        filterAndPaginatePodcasts(fallbackPodcasts, "All", 1);
      } finally {
        setLoading(false);
      }
    };

    fetchAllPodcasts();
  }, []);

  // Update category counts with specific ordering
  const updateCategories = (podcasts) => {
    const counts = {};
    const uniqueCategories = new Set();

    podcasts.forEach((podcast) => {
      const category = podcast.category || "Uncategorized";
      counts[category] = (counts[category] || 0) + 1;
      uniqueCategories.add(category);
    });

    // Define the desired order
    const categoryOrder = [
      "Solution",
      "Software", 
      "Utilities",
      "IOT",
      "AI Solutions",
      "Mobile Application",
    ];
    
    // Create ordered categories array
    const orderedCategories = [];
    
    // Add categories in the specified order
    categoryOrder.forEach(cat => {
      if (uniqueCategories.has(cat)) {
        orderedCategories.push({
          name: cat,
          count: counts[cat] || 0
        });
        uniqueCategories.delete(cat); // Remove from set after adding
      }
    });
    
    // Add any remaining categories that weren't in the predefined order
    uniqueCategories.forEach(cat => {
      orderedCategories.push({
        name: cat,
        count: counts[cat] || 0
      });
    });

    // Add "All" category at the beginning
    const dynamicCategories = [
      { name: "All", count: podcasts.length },
      ...orderedCategories
    ];

    setCategories(dynamicCategories);
  };

  // Filter and paginate podcasts client-side
  const filterAndPaginatePodcasts = (podcasts, category, page) => {
    // Filter by category
    const filtered = category === "All" 
      ? podcasts 
      : podcasts.filter(p => p.category === category);

    // Calculate pagination
    const totalPages = Math.ceil(filtered.length / postsPerPage);
    setTotalPages(totalPages);

    // Get podcasts for current page
    const startIndex = (page - 1) * postsPerPage;
    const paginatedPodcasts = filtered.slice(startIndex, startIndex + postsPerPage);

    setFilteredPodcasts(paginatedPodcasts);
  };

  // Handle filter change
  const handleFilterChange = (category) => {
    setActiveFilter(category);
    setCurrentPage(1);
    filterAndPaginatePodcasts(allPodcasts, category, 1);
  };

  // Handle page change
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    filterAndPaginatePodcasts(allPodcasts, activeFilter, pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openPodcastModal = (podcast) => {
    setSelectedPodcast(podcast);
    setShowModal(true);
  };

  const closePodcastModal = () => {
    setShowModal(false);
    setSelectedPodcast(null);
  };

  const truncateWords = (text, maxWords) => {
    if (!text) return "";
    const words = text.split(/\s+/).filter((word) => word.length > 0);
    return words.length > maxWords
      ? `${words.slice(0, maxWords).join(" ")}...`
      : text;
  };

  // if (loading && currentPage === 1) {
  //   return (
  //     <div className="flex justify-center items-center h-64">
  //       <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#00D084]"></div>
  //     </div>
  //   );
  // }

  if (error) {
    return <div className="text-center py-10 text-red-500">{error}</div>;
  }

  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Our Podcasts"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Resources" },
          { label: "Podcasts" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Podcasts @ AJEEVI"
          shareUrl="https://gyanyantram.ajeevi.in/podcast"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Podcast Modal */}
      {showModal && selectedPodcast && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl relative">
            <button
              onClick={closePodcastModal}
              className="absolute -top-10 right-0 text-white text-3xl z-50"
            >
              &times;
            </button>
            <div className="relative pt-[56.25%]">
              {" "}
              {/* 16:9 aspect ratio */}
              <iframe
                src={`https://www.youtube.com/embed/${selectedPodcast.videoId}?autoplay=1`}
                className="absolute top-0 left-0 w-full h-full rounded-t-lg"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={selectedPodcast.title}
              ></iframe>
            </div>
            <div className="p-4">
              <h3 className="text-xl font-bold">{selectedPodcast.title}</h3>
              <p className="text-gray-600 mt-2">{selectedPodcast.desc}</p>
            </div>
          </div>
        </div>
      )}

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-10 py-0 pb-5 mb-10 bg-white font-poppins">
        <h2 className="text-3xl sm:text-2xl font-medium text-[#00D084] mb-4 text-center">
          Our Podcast Gallery
        </h2>
        <h3 className="text-xl md:text-3xl font-medium text-gray-900 mb-2 text-center">
          Insights in SwachhAJV
        </h3>
        <p className="text-black text-base sm:text-lg max-w-3xl mx-auto mb-10 text-center">
          Explore the latest podcasts on sustainable practices, smart bin
          technology, AI-based waste segregation, and policy updates driving
          cleaner cities.
        </p>

        <div className="flex flex-col md:flex-row gap-8 lg:gap-2">
          {/* Left sidebar - Filters */}
          <div className="w-full md:w-1/5 lg:w-1/4">
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm sticky top-4">
              <h4 className="text-lg font-semibold mb-4 text-gray-800">
                Offerings
              </h4>
              <ul className="space-y-2">
                {categories.map((category, index) => (
                  <li key={index}>
                    <button
                      onClick={() => handleFilterChange(category.name)}
                      className={`w-full text-left px-4 py-2 rounded-md transition-colors flex justify-between items-center ${
                        activeFilter === category.name
                          ? "bg-[#00D084] text-white"
                          : "text-black hover:bg-gray-100"
                      }`}
                    >
                      <span>{category.name}</span>
                      <span className="bg-white text-[#00D084] text-xs font-semibold px-2 py-1 rounded-full">
                        {category.count}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Main content - Podcast posts */}
          <div className="w-full md:w-4/5 lg:w-3/2">
            {filteredPodcasts.length > 0 ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {filteredPodcasts.map((post, idx) => (
                    <div key={idx} className="px-2">
                      <div className="bg-gray-100 rounded-2xl shadow p-4 h-[420px] flex flex-col hover:shadow-lg transition duration-300">
                        <div className="relative mb-4 rounded-xl overflow-hidden cursor-pointer">
                          <div
                            onClick={() =>
                              post.videoId && openPodcastModal(post)
                            }
                          >
                            <img
                              src={post.img}
                              alt={post.title}
                              className="w-full h-40 object-cover"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = Policy;
                              }}
                            />
                            {post.videoId && (
                              <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-black bg-opacity-50 rounded-full p-4">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-12 w-12 text-white"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                                    />
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            )}
                          </div>
                          <span className="absolute bottom-2 left-2 bg-[#00D084] text-white px-1 py-1 text-sm font-semibold rounded-full">
                            {post.tag}
                          </span>
                        </div>
                        <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">
                          {post.title}
                        </h4>
                        <p className="text-gray-700 text-md mb-4 text-justify px-2">
                          {truncateWords(post.desc, 20)}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="flex justify-center mt-8">
                    <nav className="inline-flex rounded-md shadow">
                      <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className={`px-4 py-2 rounded-l-md border ${
                          currentPage === 1
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        Previous
                      </button>
                      {Array.from({ length: totalPages }, (_, index) => (
                        <button
                          key={index}
                          onClick={() => paginate(index + 1)}
                          className={`px-4 py-2 border-t border-b ${
                            currentPage === index + 1
                              ? "bg-[#00D084] text-white"
                              : "bg-white text-gray-700 hover:bg-gray-50"
                          }`}
                        >
                          {index + 1}
                        </button>
                      ))}
                      <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className={`px-4 py-2 rounded-r-md border ${
                          currentPage === totalPages
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        Next
                      </button>
                    </nav>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-10">
                <p className="text-gray-500">
                  No podcasts found in this category.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Podcast;


// import { Link } from "react-router-dom";
// import PageBanner from "../PageBanner";
// import SocialMediaSidebar from "../SocialMediaSidebar";
// import SectionHeader from "../SectionHeader";
// import React, { useState, useEffect } from "react";
// import axios from "axios";

// import Policy from "../../assets/images/blog3.png";
// import vishal from "../../assets/images/vishal.png";

// import Slider from "react-slick";
// import { CMSAPI } from "../../config";
// import ScrollToTopButton from "../ScrollToTopButton";

// const Podcast = () => {
//   const [activeFilter, setActiveFilter] = useState("All");
//   const [podcastPosts, setPodcastPosts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [categories, setCategories] = useState([{ name: "All", count: 0 }]);
//   const [selectedPodcast, setSelectedPodcast] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     const fetchPodcasts = async () => {
//       try {
//         const response = await axios.get(
//           `${CMSAPI}/api/Podcasts/get-podcasts?PageNo=1&PageSize=10&domain=PARKING`
//         );

//         if (response.data && response.data.data) {
//           const transformedPodcasts = response.data.data.map((podcast) => ({
//             img: podcast.photo ? `${CMSAPI}${podcast.photo}` : Policy,
//             tag: podcast.category || "Sustainability",
//             category: podcast.category || "Uncategorized",
//             title: podcast.name || "Untitled Podcast",
//             desc: podcast.about || "No description available",
//             videoId: podcast.detail || "",
//             authorImg: vishal,
//             author: "Admin",
//             date:
//               new Date(podcast.regDate).toLocaleDateString("en-US", {
//                 year: "numeric",
//                 month: "long",
//                 day: "numeric",
//               }) || "June 9, 2025",
//             slug: podcast.slug || `#${podcast.id}`,
//           }));

//           setPodcastPosts(transformedPodcasts);

//           const counts = {};
//           const uniqueCategories = new Set();

//           transformedPodcasts.forEach((post) => {
//             const category = post.category || "Uncategorized";
//             counts[category] = (counts[category] || 0) + 1;
//             uniqueCategories.add(category);
//           });

//           const dynamicCategories = [
//             { name: "All", count: transformedPodcasts.length },
//             ...Array.from(uniqueCategories).map((cat) => ({
//               name: cat,
//               count: counts[cat] || 0,
//             })),
//           ];

//           setCategories(dynamicCategories);
//         }
//       } catch (err) {
//         console.error("Error fetching podcasts:", err);
//         setError("Failed to load podcasts. Please try again later.");

//         const fallbackPodcasts = [
//           {
//             img: Policy,
//             tag: "Sustainability",
//             category: "AI Waste Management",
//             title: "Demo Podcast",
//             desc: "An example podcast about waste management",
//             videoId: "fdOfcUI_sWk",
//             authorImg: vishal,
//             author: "Admin",
//             date: "June 9, 2025",
//           },
//         ];

//         setPodcastPosts(fallbackPodcasts);
//         setCategories([
//           { name: "All", count: fallbackPodcasts.length },
//           { name: "AI Waste Management", count: fallbackPodcasts.length },
//         ]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPodcasts();
//   }, []);

//   const openPodcastModal = (podcast) => {
//     setSelectedPodcast(podcast);
//     setShowModal(true);
//   };

//   const closePodcastModal = () => {
//     setShowModal(false);
//     setSelectedPodcast(null);
//   };

//   const filteredPosts =
//     activeFilter === "All"
//       ? podcastPosts
//       : podcastPosts.filter((post) => post.category === activeFilter);

//   const sliderSettings = {
//     dots: filteredPosts.length > 3,
//     infinite: filteredPosts.length > 3,
//     speed: 500,
//     slidesToShow: Math.min(3, filteredPosts.length),
//     slidesToScroll: 1,
//     className: "custom-dots-slider",
//     autoplay: filteredPosts.length > 3,
//     autoplaySpeed: 2000,
//     rtl: false,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: Math.min(2, filteredPosts.length),
//           infinite: filteredPosts.length > 2,
//           dots: filteredPosts.length > 2,
//           autoplay: filteredPosts.length > 2,
//         },
//       },
//       {
//         breakpoint: 640,
//         settings: {
//           slidesToShow: 1,
//           infinite: filteredPosts.length > 1,
//           dots: filteredPosts.length > 1,
//           autoplay: filteredPosts.length > 1,
//         },
//       },
//     ],
//   };

//   const truncateWords = (text, maxWords) => {
//     if (!text) return "";
//     const words = text.split(/\s+/).filter((word) => word.length > 0);
//     return words.length > maxWords
//       ? `${words.slice(0, maxWords).join(" ")}...`
//       : text;
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#00D084]"></div>
//       </div>
//     );
//   }

//   if (error) {
//     return <div className="text-center py-10 text-red-500">{error}</div>;
//   }

//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Our Podcasts"
//         breadcrumb={[
//           { label: "Home", href: "/" },
//           { label: "Resources" },
//           { label: "Podcasts" },
//         ]}
//       />
//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Podcasts @ AJEEVI"
//           shareUrl="https://swmecom.ajeevi.in/podcast"
//         />
//       </div>
//       <div>
//         <ScrollToTopButton />
//       </div>

//       {/* Podcast Modal */}
//       {showModal && selectedPodcast && (
//         <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999] p-4">
//           <div className="bg-white rounded-lg w-full max-w-4xl relative">
//             <button
//               onClick={closePodcastModal}
//               className="absolute -top-10 right-0 text-white text-3xl z-50"
//             >
//               &times;
//             </button>
//             <div className="relative pt-[56.25%]">
//               {" "}
//               {/* 16:9 aspect ratio */}
//               <iframe
//                 src={`https://www.youtube.com/embed/${selectedPodcast.videoId}?autoplay=1`}
//                 className="absolute top-0 left-0 w-full h-full rounded-t-lg"
//                 frameBorder="0"
//                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                 allowFullScreen
//                 title={selectedPodcast.title}
//               ></iframe>
//             </div>
//             <div className="p-4">
//               <h3 className="text-xl font-bold">{selectedPodcast.title}</h3>
//               <p className="text-gray-600 mt-2">{selectedPodcast.desc}</p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Page content */}
//       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-10 py-0 pb-5 mb-10 bg-white font-poppins">
//         <h2 className="text-3xl sm:text-2xl font-medium text-[#00D084] mb-4 text-center">
//           Our Podcast Gallery
//         </h2>
//         <h3 className="text-xl md:text-3xl font-medium text-gray-900 mb-2 text-center">
//           Insights in GyanYantram
//         </h3>
//         <p className="text-black text-base sm:text-lg max-w-3xl mx-auto mb-10 text-center">
//           Explore the latest podcasts on digital governance, emerging smart city technologies, innovative public service solutions, and impactful policies shaping the future of urban development through GyanYantram.
//         </p>

//         <div className="flex flex-col md:flex-row gap-8 lg:gap-2">
//           {/* Left sidebar - Filters */}
//           <div className="w-full md:w-1/5 lg:w-1/4">
//             <div className="bg-gray-50 p-4 rounded-lg shadow-sm sticky top-4">
//               <h4 className="text-lg font-semibold mb-4 text-gray-800">
//                 Categories
//               </h4>
//               <ul className="space-y-2">
//                 {categories.map((category, index) => (
//                   <li key={index}>
//                     <button
//                       onClick={() => setActiveFilter(category.name)}
//                       className={`w-full text-left px-4 py-2 rounded-md transition-colors flex justify-between items-center ${
//                         activeFilter === category.name
//                           ? "bg-[#00D084] text-white"
//                           : "text-black hover:bg-gray-100"
//                       }`}
//                     >
//                       <span>{category.name}</span>
//                       <span className="bg-white text-[#00D084] text-xs font-semibold px-2 py-1 rounded-full">
//                         {category.count}
//                       </span>
//                     </button>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>

//           {/* Main content - Podcast posts */}
//           <div className="w-full md:w-4/5 lg:w-3/2">
//             {filteredPosts.length > 0 ? (
//               filteredPosts.length <= 3 ? (
//                 // Static grid with consistent card width
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                   {filteredPosts.map((post, idx) => (
//                     <div key={idx} className="px-2">
//                       <div className="bg-gray-100 rounded-2xl shadow p-4 h-[420px] flex flex-col hover:shadow-lg transition duration-300">
//                         <div className="relative mb-4 rounded-xl overflow-hidden cursor-pointer">
//                           <div
//                             onClick={() =>
//                               post.videoId && openPodcastModal(post)
//                             }
//                           >
//                             <img
//                               src={post.img}
//                               alt={post.title}
//                               className="w-full h-40 object-cover"
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = Policy;
//                               }}
//                             />
//                             {post.videoId && (
//                               <div className="absolute inset-0 flex items-center justify-center">
//                                 <div className="bg-black bg-opacity-50 rounded-full p-4">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     className="h-12 w-12 text-white"
//                                     fill="none"
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                   >
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
//                                     />
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                                     />
//                                   </svg>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                           <span className="absolute bottom-2 left-2 bg-[#00D084] text-white px-3 py-2 text-md font-semibold rounded-full">
//                             {post.tag}
//                           </span>
//                         </div>
//                         <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">
//                           {post.title}
//                         </h4>
//                         <p className="text-gray-700 text-md mb-4 text-justify px-2">
//                           {truncateWords(post.desc, 20)}
//                         </p>
//                         <div className="flex items-center mt-auto px-2">
//                           <img
//                             src={post.authorImg}
//                             alt={post.author}
//                             className="w-10 h-10 rounded-full mr-3"
//                           />
//                           <div className="text-left">
//                             <p className="text-sm font-semibold text-gray-900">
//                               {post.author}
//                             </p>
//                             <p className="text-sm text-gray-500">{post.date}</p>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                   {filteredPosts.length < 3 &&
//                     Array.from({ length: 3 - filteredPosts.length }).map(
//                       (_, idx) => (
//                         <div
//                           key={`empty-${idx}`}
//                           className="hidden md:block"
//                         ></div>
//                       )
//                     )}
//                 </div>
//               ) : (
//                 // Slider for more than 3 items
//                 <Slider {...sliderSettings}>
//                   {filteredPosts.map((post, idx) => (
//                     <div key={idx} className="px-2">
//                       <div className="bg-gray-100 rounded-2xl shadow p-4 h-[420px] flex flex-col hover:shadow-lg transition duration-300 mx-2">
//                         <div className="relative mb-4 rounded-xl overflow-hidden cursor-pointer">
//                           <div
//                             onClick={() =>
//                               post.videoId && openPodcastModal(post)
//                             }
//                           >
//                             <img
//                               src={post.img}
//                               alt={post.title}
//                               className="w-full h-40 object-cover"
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = Policy;
//                               }}
//                             />
//                             {post.videoId && (
//                               <div className="absolute inset-0 flex items-center justify-center">
//                                 <div className="bg-black bg-opacity-50 rounded-full p-4">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     className="h-12 w-12 text-white"
//                                     fill="none"
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                   >
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
//                                     />
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                                     />
//                                   </svg>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                           <span className="absolute bottom-2 left-2 bg-[#00D084] text-white px-3 py-2 text-md font-semibold rounded-full">
//                             {post.tag}
//                           </span>
//                         </div>
//                         <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">
//                           {post.title}
//                         </h4>
//                         <p className="text-gray-700 text-md mb-4 text-justify px-2">
//                           {truncateWords(post.desc, 20)}
//                         </p>
//                         <div className="flex items-center mt-auto px-2">
//                           <img
//                             src={post.authorImg}
//                             alt={post.author}
//                             className="w-10 h-10 rounded-full mr-3"
//                           />
//                           <div className="text-left">
//                             <p className="text-sm font-semibold text-gray-900">
//                               {post.author}
//                             </p>
//                             <p className="text-sm text-gray-500">{post.date}</p>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </Slider>
//               )
//             ) : (
//               <div className="text-center py-10">
//                 <p className="text-gray-500">
//                   No podcasts found in this category.
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Podcast;
